import { Container, Row, Col } from "react-bootstrap";
import NavigationBar from "../components/navigationbar";
import Footer from "../components/footer";
import greenbanner2 from "../assets/greenbanner2.png";
import waterdrop from "../assets/waterdrop.png";
import tree from "../assets/tree.png";



const NonMuslims = () => {


    return (
        <div className="position-relative">
            <NavigationBar />

            <div
                style={{
                    backgroundImage: `url(${greenbanner2})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    fontFamily: "Lora, serif",
                }}
            >
                <Container>
                    <div style={{ textAlign: "center", marginBottom: "1 rem" }} className="pt-3">
                        <h4>Greater Austin Muslim Relief Committee</h4>
                    </div>

                    <div
                        className="d-flex flex-column flex-md-row align-items-start justify-content-between"
                    >
                        {/* Left: Text */}
                        <div style={{ flex: 1, minWidth: "280px" }}>
                            <h1 className="fw-bold mb-2">Doing Good for All:</h1>
                            <h2 className="fw-semibold mb-3">Supporting Muslims and Non-Muslims Alike</h2>

                            {/* Quran verse */}
                            <div>
                                <h3 className="mb-2" style={{ fontSize: "1.25rem" }}>
                                    وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ ۖ وَلَا تَعَاوَنُوا عَلَى الْإِثْمِ وَالْعُدْوَانِ
                                </h3>
                                <p className="mb-0" style={{ fontSize: "1rem", fontWeight: "500" }}>
                                    “And cooperate in righteousness and piety, but do not cooperate in sin and aggression.”
                                </p>
                                <p className="mb-0" style={{ fontSize: "1rem", fontWeight: "500" }}>
                                    — Surah Al-Ma’idah (5:2)
                                </p>
                            </div>
                        </div>

                        {/* Right: Image */}
                        <div
                            style={{
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={waterdrop}
                                alt="Water Drop"
                                style={{
                                    maxHeight: "250px",
                                    width: "auto",
                                    objectFit: "contain",
                                }}
                            />
                        </div>
                    </div>
                </Container>
            </div>

            <Container className="my-2">
                <Row className="text-center mt-4">
                    <h2>Faith inspires us to serve all. Together, we build a kinder, stronger Austin community.</h2>
                    <h2>One Act of Kindness For All</h2>

                </Row>
                <Row className="justify-content-center">
                    <Col className="text-center">
                        <h4>
                            At the Greater Austin Muslim Relief Committee (GAMRC), we believe that compassion knows no
                            boundaries. While our mission is rooted in Islamic values and funded through Sadaqah (voluntary
                            charity given in the name of Allah), we extend our help to anyone in need — regardless of
                            faith, background, or ethnicity. We Live Here. We give here. We help here.
                        </h4>
                    </Col>
        </Row>

                <hr className="my-4" />

                <Row className="align-items-center my-2">
                    <Col xs={12} md={7}>
                        <h3 className="mb-4">Why We Help Everyone</h3>
                        <p>
                            Helping non-Muslims isn't just kindness — it's part of our duty as Muslims. Islam calls us to be a source
                            of comfort, support, and good for all people.
                        </p>
                        <p>
                            That’s why our Sadaqah-funded programs reach across faith lines — offering relief to survivors of domestic abuse,
                            meals to the hungry, and support to seniors in need. Because building a better Austin means uplifting everyone.
                        </p>
                        <Row className="align-items-center">
                            <Col>
                                <h4>Examples of Inclusive Work We Suppport: </h4>
                                <Col>
                                            <p style={{ textAlign: "justify" }}>
                                👉 <a href="/Contact">Click here to contact us.</a>
                                <br />
                                Together, let’s build a more caring and united Austin.
                            </p>
                        </Col>
                            </Col>
                        </Row>
                    </Col>

                    <Col
                        xs={12}
                        md={5}
                        className="d-flex flex-column align-items-center justify-content-center"
                    >
                        <img
                            src={tree}
                            alt="Tree"
                            style={{ width: "60%", height: "auto", borderRadius: "10px" }}
                        />
                        <h4 className="mb-2 text-center mt-3">
                            “Is there any reward for good other than good?”
                        </h4>
                        <p className="text-center" style={{ fontStyle: "italic" }}>
                            — Surah Ar-Rahman (55:60)
                        </p>
                    </Col>

                </Row>
                <Row>
                    <Col>
                        <h4>Guided By Sadaqah</h4>
                        <p>
                            All these initiatives are made possible through Sadaqah, voluntary charity that embodies the Islamic
                            value of giving freely for the sake of Allah. It allows us to uplift the entire community, fulfill
                            urgent needs, and bring comfort to those in need.
                        </p>
                    </Col>
                </Row>
                <hr className="my-4" />
               <Row className="align-items-center">
    {/* Purple Box */}
    <Col md={5} className="d-flex justify-content-center mb-4">
        <div
            className="text-center d-flex align-items-center justify-content-center"
            style={{
                backgroundColor: "#D4C5E4",
                padding: "2.5rem",
                borderRadius: "10px",
                height: "100%",
                minHeight: "200px",
                width: "100%",
            }}
        >
            <h3 className="mb-0">
                Need Help? We’re Here for You, No Matter Your Faith
            </h3>
        </div>
    </Col>

    {/* Paragraph Text */}
    <Col md={7}>
        <p style={{ fontSize: "1.05rem", lineHeight: "1.5" }}>
            At the Greater Austin Muslim Relief Committee (GAMRC), we believe in serving everyone in our community with compassion,
            dignity, and respect. If you or someone you know is in need of assistance, regardless of religious background—we are here to help.
            <br />
            Whether you're facing financial hardship, food insecurity, housing instability, or need other forms of support, you are welcome to reach out.
            </p> <p>
            👉 <a href="/FAQ#contactus">Click here to contact us.</a>
            <br />
            Together, let’s build a more caring and united Austin.
        </p>
    </Col>
</Row>

            </Container>

            <Footer />
        </div>
    );
};

export default NonMuslims;
